const sidebar = (state = [], action) => {

	switch (action.type) {

		case 'SET_SIDEBAR':

			const { status } = action.options;

			return {
				...state,
				status
			};

		default:
			return state;
	}
}
export default sidebar;



// WEBPACK FOOTER //
// ./src/reducers/sidebar.js